import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Spinner from 'react-svg-spinner';

const Image = (props) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const { renderOnError, ...propsToPass } = props;

  const onError = () => {
    setLoading(false);
    setError(true);
  };

  const onLoad = () => {
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    setError(false);
  }, [props.src]);

  const renderStatus = () => {
    if (loading) return <Spinner />;
    if (error) {
      if (renderOnError) return renderOnError;

      return <p>Error while loading image</p>;
    }
  };

  const style = (loading || error) ? {display: 'none'} : null;

  return (
    <React.Fragment>
      {renderStatus()}
      <img
        onError={onError}
        onLoad={onLoad}
        style={style}
        {...propsToPass}
      />
    </React.Fragment>
  );
};

Image.propTypes = {
  src: PropTypes.any.isRequired,
  renderOnError: PropTypes.any
};

export default Image;
